import { render, staticRenderFns } from "./OrderHistoryModal.vue?vue&type=template&id=2f7d55a8&scoped=true"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=ts"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d55a8",
  null
  
)

export default component.exports